"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _navigation = require("next/navigation");
var _react = require("react");
var _globalConstants = require("../global-constants");
var _useCookieWatcher = _interopRequireDefault(require("./use-cookie-watcher"));
var LoginActions = function (LoginActions) {
  LoginActions["LOGIN_ERROR"] = "loginError";
  LoginActions["LOGIN_SUCCESS"] = "userLoggedIn";
  return LoginActions;
}(LoginActions || {});
function useInnBusinessLogin(redirectTo, iframeSecureUrl, schema) {
  var [isError, setIsError] = (0, _react.useState)(false);
  var [isSubmitting, setIsSubmitting] = (0, _react.useState)(false);
  var [hasLoggedIn, setHasLoggedIn] = (0, _react.useState)(false);
  var isTokenSet = (0, _useCookieWatcher.default)(_globalConstants.ID_TOKEN_COOKIE, 500);
  var router = (0, _navigation.useRouter)();
  (0, _react.useEffect)(() => {
    var handleMessages = message => {
      if ((message === null || message === void 0 ? void 0 : message.origin) === iframeSecureUrl) {
        var data;
        try {
          data = typeof (message === null || message === void 0 ? void 0 : message.data) === 'string' ? JSON.parse(message.data) : message.data;
        } catch (_unused) {
          data = message.data;
        }
        var action = data.action;
        if (action === LoginActions.LOGIN_ERROR) {
          setIsError(true);
          setIsSubmitting(false);
        } else if (action === LoginActions.LOGIN_SUCCESS) {
          setIsError(false);
          setHasLoggedIn(true);
        }
      } else {
        setIsError(true);
        setIsSubmitting(false);
      }
    };
    window.addEventListener('message', handleMessages);
    return () => {
      window.removeEventListener('message', handleMessages);
    };
  }, [redirectTo]);
  (0, _react.useEffect)(() => {
    if (hasLoggedIn && isTokenSet) {
      router.replace(redirectTo);
      router.refresh();
    }
  }, [isTokenSet, hasLoggedIn]);
  var handleLogin = data => {
    var authIframe = document.getElementById('authIframe');
    if (authIframe !== null && authIframe !== void 0 && authIframe.contentWindow) {
      setIsSubmitting(true);
      var message = JSON.stringify({
        action: 'login',
        username: data.email,
        password: data.password,
        isBusiness: true
      });
      try {
        authIframe.contentWindow.postMessage(message, iframeSecureUrl);
      } catch (error) {
        setIsError(true);
        setIsSubmitting(false);
      }
    } else {
      setIsError(true);
    }
  };
  return {
    isError,
    isSubmitting,
    handleLogin
  };
}
var _default = exports.default = useInnBusinessLogin;